import * as CONSTANTES from '../utils/constantes'
import * as Funciones from '../utils/funciones'
import { getScreenNameAuthenticated } from './auth/Auth-utils';
import * as FuncionesServices from "./funciones-services";

const agregarParametros = (url, arrayParametros) => {
  let urlSalida = url
  arrayParametros.map((parametro, index) => {
    if (index === 0) {
      urlSalida = urlSalida + '?'
    } else {
      urlSalida = urlSalida + '&'
    }
    urlSalida = urlSalida + parametro.campo + '=' + parametro.valor
    return parametro
  })
  return urlSalida
}

const obtenerMensajeErrorGeneral = (error) => {
  switch (error && error.status) {
    case 401: {
      return CONSTANTES.MENSAJE_ERROR_SERVICIO_401
    }

    case 404: {
      return CONSTANTES.MENSAJE_ERROR_SERVICIO_404
    }

    case 406: {
      return CONSTANTES.MENSAJE_ERROR_SERVICIO_406
    }

    case 500: {
      return CONSTANTES.MENSAJE_ERROR_SERVICIO_500
    }

    default: {
      return CONSTANTES.MENSAJE_ERROR_SERVICIO_GENERICO
    }
  }
}

//Se cambio por el servicio del NGNIX
export const getTokenAccess = async () => {
  let salidaJson = {
    error: false,
    mensajeError: null,
    res: {}
  }

  try {
    const response = await fetch(process.env.REACT_APP_WS_GET_TOKEN_ACCESS, {
      method: 'post',
      headers: {
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY_NGINX,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        resource: process.env.REACT_APP_RESOURCE_ID
      })
    })

    if (response.ok) {
      if (response.headers.get('content-type') !== 'text/html') {
        const res = await response.json()
        if (res.Status === 'fail') {
          salidaJson.error = true
          salidaJson.mensajeError = res.Message
        } else {
          salidaJson.error = false
          salidaJson.res = res
        }
      } else {
        salidaJson.error = true
        salidaJson.mensajeError = obtenerMensajeErrorGeneral(null)
      }
    } else {
      salidaJson.error = true
      salidaJson.res = response
      salidaJson.mensajeError = obtenerMensajeErrorGeneral(salidaJson.res)
    }
  } catch (error) {
    console.error(error)
  }

  return salidaJson
}

export const getIamToken = () => {
  return localStorage.getItem('msal.idtoken')
}

export const getAsegurado = async (usuario, idSolicitudMultiple) => {
  let salidaJson = {
    error: false,
    mensajeError: null,
    res: {}
  }

  try {
    //Mapeo Campos
    let atributos = [{ campo: 'idSolicitudMultiple', valor: idSolicitudMultiple }]

    const response = await fetch(Funciones.reemplazarUrlServicio(process.env.REACT_APP_WS_GET_ASEGURADO, atributos), {
      method: 'get',
      headers: {
        Authorization: 'Bearer ' + FuncionesServices.getAccessToken(),
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY,
        transactionId: Funciones.generarCorrelativo(),
        correlationId: Funciones.generarCorrelativo(),
        businessProcess: process.env.REACT_APP_BUSINESS_PROCESS,
        applicationName: process.env.REACT_APP_NOMBRE_APLICACION,
        applicationUser: getScreenNameAuthenticated()
      }
    })

    if (response.ok) {
      if (response.headers.get('content-type') !== 'text/html') {
        const res = await response.json()
        if (res.Status === 'fail') {
          salidaJson.error = true
          salidaJson.mensajeError = res.Message
        } else {
          salidaJson.error = false
          salidaJson.res = res.data
        }
      } else {
        salidaJson.error = true
        salidaJson.mensajeError = obtenerMensajeErrorGeneral(null)
      }
    } else {
      salidaJson.error = true
      salidaJson.res = response
      salidaJson.mensajeError = obtenerMensajeErrorGeneral(salidaJson.res)
    }
  } catch (error) {
    console.error(error)
  }

  return salidaJson
}

export const postAseguradoOtrosDatos = async (usuario, idSolicitudMultiple, otrosDatos) => {

  let salidaJson = {
    error: false,
    mensajeError: null,
    res: {}
  }

  try {

    let atributos = [
      { campo: 'idSolicitudMultiple', valor: idSolicitudMultiple }
    ]

    const response = await fetch(Funciones.reemplazarUrlServicio(process.env.REACT_APP_WS_POST_ASEGURADO_OTROS_DATOS, atributos), {
      method: 'post',
      headers: {
        Authorization: 'Bearer ' + FuncionesServices.getAccessToken(),
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY,
        transactionId: Funciones.generarCorrelativo(),
        correlationId: Funciones.generarCorrelativo(),
        businessProcess: process.env.REACT_APP_BUSINESS_PROCESS,
        applicationName: process.env.REACT_APP_NOMBRE_APLICACION,
        applicationUser: getScreenNameAuthenticated()
      },
      body: JSON.stringify(otrosDatos)
    })

    if (response.ok) {
      if (response.headers.get('content-type') !== 'text/html') {
        const res = await response.json()
        if (res.status === 'error') {
          salidaJson.error = true
          salidaJson.mensajeError = res.message
        } else if (res.Status === 'fail') {
          salidaJson.error = true
          salidaJson.mensajeError = res.Message
        } else {
          salidaJson.error = false
          salidaJson.res = res
        }
      } else {
        salidaJson.error = true
        salidaJson.mensajeError = obtenerMensajeErrorGeneral(null)
      }
    } else {
      salidaJson.error = true
      salidaJson.res = response
      salidaJson.mensajeError = obtenerMensajeErrorGeneral(salidaJson.res)
    }
  } catch (error) {
    console.error(error)
  }

  return salidaJson
}


export const postAsegurado = async (usuario, idSolicitudMultiple, asegurado) => {
  let salidaJson = {
    error: false,
    mensajeError: null,
    res: {}
  }

  try {
    let atributos = [{ campo: 'idSolicitudMultiple', valor: idSolicitudMultiple }]

    const response = await fetch(Funciones.reemplazarUrlServicio(process.env.REACT_APP_WS_POST_ASEGURADO, atributos), {
      method: 'post',
      headers: {
        Authorization: 'Bearer ' + FuncionesServices.getAccessToken(),
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY,
        transactionId: Funciones.generarCorrelativo(),
        correlationId: Funciones.generarCorrelativo(),
        businessProcess: process.env.REACT_APP_BUSINESS_PROCESS,
        applicationName: process.env.REACT_APP_NOMBRE_APLICACION,
        applicationUser: getScreenNameAuthenticated()
      },
      body: JSON.stringify({
        idAsegurado: asegurado.idAsegurado,
        usuario: asegurado.usuario,
        contacto: asegurado.contacto,
        respuestas: asegurado.respuestas,
        otrosSeguros: asegurado.otrosSeguros
      })
    })

    if (response.ok) {
      if (response.headers.get('content-type') !== 'text/html') {
        const res = await response.json()
        if (res.Status === 'error') {
          salidaJson.error = true
          salidaJson.mensajeError = res.Message
        } else {
          salidaJson.error = false
          salidaJson.res = res
        }
      } else {
        salidaJson.error = true
        salidaJson.mensajeError = obtenerMensajeErrorGeneral(null)
      }
    } else {
      salidaJson.error = true
      salidaJson.res = response
      salidaJson.mensajeError = obtenerMensajeErrorGeneral(salidaJson.res)
    }
  } catch (error) {
    console.error(error)
  }

  return salidaJson
}

export const postDeclaracionSalud = async (user, idSolicitudMultiple, assessmentId, coberturas, usuario) => {
  let salidaJson = {
    error: false,
    mensajeError: null,
    res: {}
  }

  try {
    let atributos = [{ campo: 'idSolicitudMultiple', valor: idSolicitudMultiple }]

    const response = await fetch(Funciones.reemplazarUrlServicio(process.env.REACT_APP_WS_POST_ASEGURADO_DECLARACIONSALUD, atributos), {
      method: 'post',
      headers: {
        Authorization: 'Bearer ' + FuncionesServices.getAccessToken(),
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY,
        transactionId: Funciones.generarCorrelativo(),
        correlationId: Funciones.generarCorrelativo(),
        businessProcess: process.env.REACT_APP_BUSINESS_PROCESS,
        applicationName: process.env.REACT_APP_NOMBRE_APLICACION,
        applicationUser: getScreenNameAuthenticated()
      },
      body: JSON.stringify({
        assessmentId: assessmentId,
        coberturas: coberturas,
        usuario: usuario,
      })
    })

    if (response.ok) {
      if (response.headers.get('content-type') !== 'text/html') {
        const res = await response.json()
        if (res.Status === 'error') {
          salidaJson.error = true
          salidaJson.mensajeError = res.Message
        } else {
          salidaJson.error = false
          salidaJson.res = res
        }
      } else {
        salidaJson.error = true
        salidaJson.mensajeError = obtenerMensajeErrorGeneral(null)
      }
    } else {
      salidaJson.error = true
      salidaJson.res = response
      salidaJson.mensajeError = obtenerMensajeErrorGeneral(salidaJson.res)
    }
  } catch (error) {
    console.error(error)
  }

  return salidaJson
}

export const putAsegurado = async (usuario, idSolicitudMultiple, asegurado) => {
  let salidaJson = {
    error: false,
    mensajeError: null,
    res: {}
  }

  try {
    //Mapeo Campos
    let atributos = [
      { campo: 'idSolicitudMultiple', valor: idSolicitudMultiple },
      { campo: 'idAsegurado', valor: asegurado.idAsegurado }
    ]

    const response = await fetch(Funciones.reemplazarUrlServicio(process.env.REACT_APP_WS_PUT_ASEGURADO, atributos), {
      method: 'put',
      headers: {
        Authorization: 'Bearer ' + FuncionesServices.getAccessToken(),
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY,
        transactionId: Funciones.generarCorrelativo(),
        correlationId: Funciones.generarCorrelativo(),
        businessProcess: process.env.REACT_APP_BUSINESS_PROCESS,
        applicationName: process.env.REACT_APP_NOMBRE_APLICACION,
        applicationUser: getScreenNameAuthenticated()
      },
      body: JSON.stringify(asegurado)
    })

    if (response.ok) {
      if (response.headers.get('content-type') !== 'text/html') {
        const res = await response.json()
        if (res.status === 'error') {
          salidaJson.error = true
          salidaJson.mensajeError = res.message
        } else if (res.Status === 'fail') {
          salidaJson.error = true
          salidaJson.mensajeError = res.Message
        } else {
          salidaJson.error = false
          salidaJson.res = res
        }
      } else {
        salidaJson.error = true
        salidaJson.mensajeError = obtenerMensajeErrorGeneral(null)
      }
    } else {
      salidaJson.error = true
      salidaJson.res = response
      salidaJson.mensajeError = obtenerMensajeErrorGeneral(salidaJson.res)
    }
  } catch (error) {
    console.error(error)
  }

  return salidaJson
}

export const getFamiliares = async (usuario, idSolicitudMultiple) => {
  let salidaJson = {
    error: false,
    mensajeError: null,
    res: {}
  }

  try {
    let atributos = [{ campo: 'idSolicitudMultiple', valor: idSolicitudMultiple }]

    const response = await fetch(Funciones.reemplazarUrlServicio(process.env.REACT_APP_WS_GET_FAMILIARES, atributos), {
      headers: {
        Authorization: 'Bearer ' + FuncionesServices.getAccessToken(),
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY,
        transactionId: Funciones.generarCorrelativo(),
        correlationId: Funciones.generarCorrelativo(),
        businessProcess: process.env.REACT_APP_BUSINESS_PROCESS,
        applicationName: process.env.REACT_APP_NOMBRE_APLICACION,
        applicationUser: getScreenNameAuthenticated()
      },
    })

    if (response.ok) {
      if (response.headers.get('content-type') !== 'text/html') {
        const res = await response.json()
        if (res.code === 200 && res.status === 'Success') {
          salidaJson.error = false
          salidaJson.res = res.data
        } else {
          salidaJson.error = true
          salidaJson.res = res.data
          salidaJson.mensajeError = obtenerMensajeErrorGeneral(null)
        }
      } else {
        salidaJson.error = true
        salidaJson.mensajeError = obtenerMensajeErrorGeneral(null)
      }
    } else {
      salidaJson.error = true
      salidaJson.res = response
      salidaJson.mensajeError = obtenerMensajeErrorGeneral(salidaJson.res)
    }
  } catch (error) {
    console.error(error)
  }

  return salidaJson
}

export const getFamiliaresId = async (usuario, idSolicitudMultiple, id) => {
  let salidaJson = {
    error: false,
    mensajeError: null,
    res: {}
  }

  try {
    let atributos = [
      { campo: 'idSolicitudMultiple', valor: idSolicitudMultiple },
      { campo: 'id', valor: id },
    ]

    const response = await fetch(Funciones.reemplazarUrlServicio(process.env.REACT_APP_WS_GET_FAMILIARES_ID, atributos), {
      headers: {
        Authorization: 'Bearer ' + FuncionesServices.getAccessToken(),
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY,
        transactionId: Funciones.generarCorrelativo(),
        correlationId: Funciones.generarCorrelativo(),
        businessProcess: process.env.REACT_APP_BUSINESS_PROCESS,
        applicationName: process.env.REACT_APP_NOMBRE_APLICACION,
        applicationUser: getScreenNameAuthenticated()
      },
    })

    if (response.ok) {
      if (response.headers.get('content-type') !== 'text/html') {
        const res = await response.json()
        if (res.Status === 'fail') {
          salidaJson.error = true
          salidaJson.mensajeError = res.Message
        } else {
          salidaJson.error = false
          salidaJson.res = res.data
        }
      } else {
        salidaJson.error = true
        salidaJson.mensajeError = obtenerMensajeErrorGeneral(null)
      }
    } else {
      salidaJson.error = true
      salidaJson.res = response
      salidaJson.mensajeError = obtenerMensajeErrorGeneral(salidaJson.res)
    }
  } catch (error) {
    console.error(error)
  }

  return salidaJson
}

export const postFamiliares = async (usuario, idSolicitudMultiple, familiar) => {
  let salidaJson = {
    error: false,
    mensajeError: null,
    res: {}
  }

  try {
    let atributos = [{ campo: 'idSolicitudMultiple', valor: idSolicitudMultiple }]

    const response = await fetch(Funciones.reemplazarUrlServicio(process.env.REACT_APP_WS_POST_FAMILIARES, atributos), {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + FuncionesServices.getAccessToken(),
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY,
        transactionId: Funciones.generarCorrelativo(),
        correlationId: Funciones.generarCorrelativo(),
        businessProcess: process.env.REACT_APP_BUSINESS_PROCESS,
        applicationName: process.env.REACT_APP_NOMBRE_APLICACION,
        applicationUser: getScreenNameAuthenticated()
      },
      body: JSON.stringify({
        usuario: familiar.usuario,
        numeroFamiliar: familiar.numeroFamiliar,
        nombres: familiar.nombres,
        apellidoPaterno: familiar.apellidoPaterno,
        apellidoMaterno: familiar.apellidoMaterno,
        parentesco: familiar.parentesco,
        tipoDocumento: familiar.tipoDocumento,
        numeroDocumento: familiar.numeroDocumento,
        ocupacion: familiar.ocupacion,
        sexo: familiar.sexo,
        fechaNacimiento: familiar.fechaNacimiento,
      }),
    })

    if (response.ok) {
      if (response.headers.get('content-type') !== 'text/html') {
        const res = await response.json()
        if (res.Status === 'error') {
          salidaJson.error = true
          salidaJson.mensajeError = res.Message
        } else {
          salidaJson.error = false
          salidaJson.res = res
        }
      } else {
        salidaJson.error = true
        salidaJson.mensajeError = obtenerMensajeErrorGeneral(null)
      }
    } else {
      salidaJson.error = true
      salidaJson.res = response
      salidaJson.mensajeError = obtenerMensajeErrorGeneral(salidaJson.res)
    }
  } catch (error) {
    console.error(error)
  }

  return salidaJson
}

export const putFamiliares = async (usuario, idSolicitudMultiple, familiar) => {
  let salidaJson = {
    error: false,
    mensajeError: null,
    res: {}
  }

  try {
    let atributos = [
      { campo: 'idSolicitudMultiple', valor: idSolicitudMultiple },
      { campo: 'id', valor: familiar.idFamiliar },
    ]

    const response = await fetch(Funciones.reemplazarUrlServicio(process.env.REACT_APP_WS_PUT_FAMILIARES, atributos), {
      method: 'put',
      headers: {
        Authorization: 'Bearer ' + FuncionesServices.getAccessToken(),
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY,
        transactionId: Funciones.generarCorrelativo(),
        correlationId: Funciones.generarCorrelativo(),
        businessProcess: process.env.REACT_APP_BUSINESS_PROCESS,
        applicationName: process.env.REACT_APP_NOMBRE_APLICACION,
        applicationUser: getScreenNameAuthenticated()
      },
      body: JSON.stringify(familiar),
    })

    if (response.ok) {
      if (response.headers.get('content-type') !== 'text/html') {
        const res = await response.json()
        if (res.Status === 'fail') {
          salidaJson.error = true
          salidaJson.mensajeError = res.Message
        } else {
          salidaJson.error = false
          salidaJson.res = res
        }
      } else {
        salidaJson.error = true
        salidaJson.mensajeError = obtenerMensajeErrorGeneral(null)
      }
    } else {
      salidaJson.error = true
      salidaJson.res = response
      salidaJson.mensajeError = obtenerMensajeErrorGeneral(salidaJson.res)
    }
  } catch (error) {
    console.error(error)
  }

  return salidaJson
}

export const deleteFamiliaresId = async (usuario, idSolicitudMultiple, id) => {
  let salidaJson = {
    error: false,
    mensajeError: null,
    res: {},
  }
  try {
    let atributos = [
      { campo: 'idSolicitudMultiple', valor: idSolicitudMultiple },
      { campo: 'id', valor: id },
    ]
    const response = await fetch(Funciones.reemplazarUrlServicio(process.env.REACT_APP_WS_DELETE_FAMILIARES, atributos), {
      method: 'delete',
      headers: {
        Authorization: 'Bearer ' + FuncionesServices.getAccessToken(),
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY,
        transactionId: Funciones.generarCorrelativo(),
        correlationId: Funciones.generarCorrelativo(),
        businessProcess: process.env.REACT_APP_BUSINESS_PROCESS,
        applicationName: process.env.REACT_APP_NOMBRE_APLICACION,
        applicationUser: getScreenNameAuthenticated()
      },
    })
    if (response.ok) {
      if (response.headers.get('content-type') !== 'text/html') {
        const res = await response.json()
        if (res.Status === 'error') {
          salidaJson.error = true
          salidaJson.mensajeError = res.Message
        } else {
          salidaJson.error = false
          salidaJson.res = res
        }
      } else {
        salidaJson.error = true
        salidaJson.mensajeError = obtenerMensajeErrorGeneral(null)
      }
    } else {
      salidaJson.error = true
      salidaJson.res = response
      salidaJson.mensajeError = obtenerMensajeErrorGeneral(salidaJson.res)
    }
  } catch (error) {
    console.error(error)
  }
  return salidaJson
}

export const getContratante = async (usuario, idSolicitudMultiple) => {
  let salidaJson = {
    error: false,
    mensajeError: null,
    res: {}
  }

  try {
    //Mapeo Campos
    let atributos = [{ campo: 'idSolicitudMultiple', valor: idSolicitudMultiple }]

    const response = await fetch(Funciones.reemplazarUrlServicio(process.env.REACT_APP_WS_GET_CONTRATANTE, atributos), {
      method: 'get',
      headers: {
        Authorization: 'Bearer ' + FuncionesServices.getAccessToken(),
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY,
        transactionId: Funciones.generarCorrelativo(),
        correlationId: Funciones.generarCorrelativo(),
        businessProcess: process.env.REACT_APP_BUSINESS_PROCESS,
        applicationName: process.env.REACT_APP_NOMBRE_APLICACION,
        applicationUser: getScreenNameAuthenticated()
      }
    })

    if (response.ok) {
      if (response.headers.get('content-type') !== 'text/html') {
        const res = await response.json()
        if (res.Status === 'error') {
          salidaJson.error = true
          salidaJson.mensajeError = res.Message
        } else {
          salidaJson.error = false
          salidaJson.res = res.data
        }
      } else {
        salidaJson.error = true
        salidaJson.mensajeError = obtenerMensajeErrorGeneral(null)
      }
    } else {
      salidaJson.error = true
      salidaJson.res = response
      salidaJson.mensajeError = obtenerMensajeErrorGeneral(salidaJson.res)
    }
  } catch (error) {
    console.error(error)
  }

  return salidaJson
}

export const postContratante = async (usuario, contratante) => {
  let salidaJson = {
    error: false,
    mensajeError: null,
    res: {}
  }

  try {
    //Mapeo Campos
    let atributos = [
      { campo: 'idSolicitudMultiple', valor: contratante.idSolicitudMultiple }
    ]

    const response = await fetch(Funciones.reemplazarUrlServicio(process.env.REACT_APP_WS_POST_CONTRATANTE, atributos), {
      method: 'post',
      headers: {
        Authorization: 'Bearer ' + FuncionesServices.getAccessToken(),
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY,
        transactionId: Funciones.generarCorrelativo(),
        correlationId: Funciones.generarCorrelativo(),
        businessProcess: process.env.REACT_APP_BUSINESS_PROCESS,
        applicationName: process.env.REACT_APP_NOMBRE_APLICACION,
        applicationUser: getScreenNameAuthenticated()
      },
      body: JSON.stringify(contratante)
    })

    if (response.ok) {
      if (response.headers.get('content-type') !== 'text/html') {
        const res = await response.json()
        if (res.status === 'error') {
          salidaJson.error = true
          salidaJson.mensajeError = res.message
        } else if (res.Status === 'fail') {
          salidaJson.error = true
          salidaJson.mensajeError = res.Message
        } else {
          salidaJson.error = false
          salidaJson.res = res
        }
      } else {
        salidaJson.error = true
        salidaJson.mensajeError = obtenerMensajeErrorGeneral(null)
      }
    } else {
      salidaJson.error = true
      salidaJson.res = response
      salidaJson.mensajeError = obtenerMensajeErrorGeneral(salidaJson.res)
    }
  } catch (error) {
    console.error(error)
  }

  return salidaJson
}

export const putContratante = async (usuario, contratante) => {
  let salidaJson = {
    error: false,
    mensajeError: null,
    res: {}
  }

  try {
    //contratante.usuario = 'sd-web'
    //Mapeo Campos
    let atributos = [
      { campo: 'idSolicitudMultiple', valor: contratante.idSolicitudMultiple },
      { campo: 'idContratante', valor: contratante.idContratante }
    ]

    const response = await fetch(Funciones.reemplazarUrlServicio(process.env.REACT_APP_WS_PUT_CONTRATANTE, atributos), {
      method: 'put',
      headers: {
        Authorization: 'Bearer ' + FuncionesServices.getAccessToken(),
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY,
        transactionId: Funciones.generarCorrelativo(),
        correlationId: Funciones.generarCorrelativo(),
        businessProcess: process.env.REACT_APP_BUSINESS_PROCESS,
        applicationName: process.env.REACT_APP_NOMBRE_APLICACION,
        applicationUser: getScreenNameAuthenticated()
      },
      body: JSON.stringify(contratante)
    })

    if (response.ok) {
      if (response.headers.get('content-type') !== 'text/html') {
        const res = await response.json()
        if (res.status === 'error') {
          salidaJson.error = true
          salidaJson.mensajeError = res.message
        } else if (res.Status === 'fail' || res.Status === 'error') {
          salidaJson.error = true
          salidaJson.mensajeError = res.Message
        } else {
          salidaJson.error = false
          salidaJson.res = res
        }
      } else {
        salidaJson.error = true
        salidaJson.mensajeError = obtenerMensajeErrorGeneral(null)
      }
    } else {
      salidaJson.error = true
      salidaJson.res = response
      salidaJson.mensajeError = obtenerMensajeErrorGeneral(salidaJson.res)
    }
  } catch (error) {
    console.error(error)
  }

  return salidaJson
}

export const getIniciarCuestionario = async (usuario, request) => {
  let salidaJson = {
    error: false,
    mensajeError: null,
    res: {}
  }

  const response = await fetch(process.env.REACT_APP_WS_SUSCRIPCION_INICIAR_CUESTIONARIO, {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + FuncionesServices.getAccessToken(),
      'Content-Type': 'application/json',
      'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY,
      transactionId: Funciones.generarCorrelativo(),
      correlationId: Funciones.generarCorrelativo(),
      businessProcess: process.env.REACT_APP_BUSINESS_PROCESS,
      applicationName: process.env.REACT_APP_NOMBRE_APLICACION,
      applicationUser: getScreenNameAuthenticated()
    },
    body: JSON.stringify(request),
  })

  if (response.ok) {
    if (response.headers.get('content-type') !== 'text/html') {
      const res = await response.json()
      salidaJson.error = false
      salidaJson.res = res
    } else {
      salidaJson.error = true
      salidaJson.mensajeError = obtenerMensajeErrorGeneral(null)
    }
  } else {
    salidaJson.error = true
    salidaJson.res = response
    salidaJson.mensajeError = obtenerMensajeErrorGeneral(salidaJson.res)
  }

  return salidaJson
}

export const suscripcionMostrarResultado = async (usuario, request) => {
  let salidaJson = {
    error: false,
    mensajeError: null,
    res: {}
  }

  const response = await fetch(process.env.REACT_APP_WS_SUSCRIPCION_MOSTRAR_RESULTADO, {
    method: 'post',
    headers: {
      Authorization: 'Bearer ' + FuncionesServices.getAccessToken(),
      'Content-Type': 'application/json',
      'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY,
      transactionId: Funciones.generarCorrelativo(),
      correlationId: Funciones.generarCorrelativo(),
      businessProcess: process.env.REACT_APP_BUSINESS_PROCESS,
      applicationName: process.env.REACT_APP_NOMBRE_APLICACION,
      applicationUser: getScreenNameAuthenticated()
    },
    body: JSON.stringify(request),
  })

  if (response.ok) {
    if (response.headers.get('content-type') !== 'text/html') {
      const res = await response.json()
      salidaJson.error = false
      salidaJson.res = res
    } else {
      salidaJson.error = true
      salidaJson.mensajeError = obtenerMensajeErrorGeneral(null)
    }
  } else if (response.status === 406) {
    salidaJson.error = false
    salidaJson.res = false
    salidaJson.mensajeError = 'Debe completar el formulario de suscripción'
  } else {
    salidaJson.error = true
    salidaJson.res = response
    salidaJson.mensajeError = obtenerMensajeErrorGeneral(salidaJson.res)
  }
  return salidaJson
}

export const obtenerPersonID = async (usuario, numdoc) => {
  //Mapeo Campos
  let salidaJson = {
    error: false,
    mensajeError: null,
    res: {}
  }

  let atributos = [{ campo: 'numDocumento', valor: numdoc }]
  const response = await fetch(Funciones.reemplazarUrlServicio(process.env.REACT_APP_WS_OBTENER_PERSON_ID, atributos), {
    method: 'GET',
    headers: {
      Authorization: 'Bearer ' + FuncionesServices.getAccessToken(),
      'Content-Type': 'application/json',
      'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY
    },
  })

  if (response.ok) {
    if (response.headers.get('content-type') !== 'text/html') {
      const res = await response.json()
      if (res.auditResponse.codigoRespuesta === '2' || res.auditResponse.codigoRespuesta === '-5') {
        salidaJson.error = true
        salidaJson.res = response
        salidaJson.mensajeError = res.auditResponse.mensajeRespuesta
      } else {
        salidaJson.error = false
        salidaJson.res = res
      }
    } else {
      salidaJson.error = true
      salidaJson.mensajeError = obtenerMensajeErrorGeneral(null)
    }
  } else {
    salidaJson.error = true
    salidaJson.res = response
    salidaJson.mensajeError = obtenerMensajeErrorGeneral(salidaJson.res)
  }

  return salidaJson
}

export const obtenerProspectoPorCodigoCotizacionWS = async (
  usuario,
  idProspecto,
  codigoCotizacion
) => {
  let salidaJson = {
    error: false,
    mensajeError: null,
    res: {}
  }

  //Mapeo Campos
  let atributos = [
    { campo: 'idProspecto', valor: idProspecto },
    { campo: 'codigoCotizacion', valor: codigoCotizacion },
  ]
  const response = await fetch(Funciones.reemplazarUrlServicio(process.env.REACT_APP_WS_PROSPECTO_X_CODIGO_COTIZACION, atributos), {
    method: 'GET',
    headers: {
      Authorization: 'Bearer ' + FuncionesServices.getAccessToken(),
      'Content-Type': 'application/json',
      'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY,
      transactionId: Funciones.generarCorrelativo(),
      correlationId: Funciones.generarCorrelativo(),
      businessProcess: process.env.REACT_APP_BUSINESS_PROCESS,
      applicationName: process.env.REACT_APP_NOMBRE_APLICACION,
      applicationUser: getScreenNameAuthenticated()
    },
  })

  if (response.ok) {
    if (response.headers.get('content-type') !== 'text/html') {
      const res = await response.json()
      salidaJson.error = false
      salidaJson.res = res.data
    } else {
      salidaJson.error = true
      salidaJson.mensajeError = obtenerMensajeErrorGeneral(null)
    }
  } else {
    salidaJson.error = true
    salidaJson.res = response
    salidaJson.mensajeError = obtenerMensajeErrorGeneral(salidaJson.res)
  }
  return salidaJson
}

export const obtenerListaProductos = async (usuario, idSolicitudMultiple) => {
  let salidaJson = {
    error: false,
    mensajeError: null,
    res: {}
  }

  try {
    let atributos = [{ campo: 'idSolicitudMultiple', valor: idSolicitudMultiple }]

    const response = await fetch(Funciones.reemplazarUrlServicio(process.env.REACT_APP_WS_PRODUCTOS_X_IDSOLICITUDMULTIPLE, atributos), {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + FuncionesServices.getAccessToken(),
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY,
        transactionId: Funciones.generarCorrelativo(),
        correlationId: Funciones.generarCorrelativo(),
        businessProcess: process.env.REACT_APP_BUSINESS_PROCESS,
        applicationName: process.env.REACT_APP_NOMBRE_APLICACION,
        applicationUser: getScreenNameAuthenticated()
      },
    })

    if (response.ok) {
      if (response.headers.get('content-type') !== 'text/html') {
        const res = await response.json()
        if (res.Status === 'error') {
          salidaJson.error = true
          salidaJson.mensajeError = res.Message
        } else {
          salidaJson.error = false
          salidaJson.res = res.data
        }
      } else {
        salidaJson.error = true
        salidaJson.mensajeError = obtenerMensajeErrorGeneral(null)
      }
    } else {
      salidaJson.error = true
      salidaJson.res = response
      salidaJson.mensajeError = obtenerMensajeErrorGeneral(salidaJson.res)
    }
  } catch (error) {
    console.error(error)
  }

  return salidaJson
}

export const obtenerListaBeneficiosPorProducto = async (usuario, codigosBeneficio) => {
  let salidaJson = {
    error: false,
    mensajeError: null,
    res: {}
  }

  try {
    let atributos = [{ campo: 'codigosBeneficio', valor: codigosBeneficio }]

    const response = await fetch(Funciones.reemplazarUrlServicio(process.env.REACT_APP_WS_GET_BENEFICIOS_POR_PRODUCTO, atributos), {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + FuncionesServices.getAccessToken(),
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY,
        idTransaccion: Funciones.generarCorrelativo(),
        correlativoId: Funciones.generarCorrelativo(),
        procesoNegocio: process.env.REACT_APP_BUSINESS_PROCESS,
        nombreAplicacion: process.env.REACT_APP_NOMBRE_APLICACION,
        usuarioAplicacion: 'test'//usuario.roles[0].codigo
      },
    })

    if (response.ok) {
      if (response.headers.get('content-type') !== 'text/html') {
        const res = await response.json()
        if (res.Status === 'error') {
          salidaJson.error = true
          salidaJson.mensajeError = res.Message
        } else {
          salidaJson.error = false
          salidaJson.res = res
        }
      } else {
        salidaJson.error = true
        salidaJson.mensajeError = obtenerMensajeErrorGeneral(null)
      }
    } else {
      salidaJson.error = true
      salidaJson.res = response
      salidaJson.mensajeError = obtenerMensajeErrorGeneral(salidaJson.res)
    }
  } catch (error) {
    console.error(error)
  }

  return salidaJson
}

export const getSolicitudes = async (usuario, idSolicitudMultiple) => {
  let salidaJson = {
    error: false,
    mensajeError: null,
    res: {}
  }

  try {
    let atributos = [{ campo: 'idSolicitudMultiple', valor: idSolicitudMultiple }]

    const response = await fetch(Funciones.reemplazarUrlServicio(process.env.REACT_APP_WS_GET_SOLICITUDES, atributos), {
      method: 'get',
      headers: {
        Authorization: 'Bearer ' + FuncionesServices.getAccessToken(),
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY,
        transactionId: Funciones.generarCorrelativo(),
        correlationId: Funciones.generarCorrelativo(),
        businessProcess: process.env.REACT_APP_BUSINESS_PROCESS,
        applicationName: process.env.REACT_APP_NOMBRE_APLICACION,
        applicationUser: getScreenNameAuthenticated()
      }
    })

    if (response.ok) {
      if (response.headers.get('content-type') !== 'text/html') {
        const res = await response.json()
        if (res.Status === 'fail') {
          salidaJson.error = true
          salidaJson.mensajeError = res.Message
        } else {
          salidaJson.error = false
          salidaJson.res = res.data
        }
      } else {
        salidaJson.error = true
        salidaJson.mensajeError = obtenerMensajeErrorGeneral(null)
      }
    } else {
      salidaJson.error = true
      salidaJson.res = response
      salidaJson.mensajeError = obtenerMensajeErrorGeneral(salidaJson.res)
    }
  } catch (error) {
    console.error(error)
  }

  return salidaJson
}

export const putSolicitudes = async (usuario, solicitud, idSolicitudMultiple) => {
  let salidaJson = {
    error: false,
    mensajeError: null,
    res: {}
  }

  try {
    let atributos = [{ campo: 'idSolicitudMultiple', valor: idSolicitudMultiple }]

    const response = await fetch(Funciones.reemplazarUrlServicio(process.env.REACT_APP_WS_PUT_SOLICITUDES, atributos), {
      method: 'put',
      headers: {
        Authorization: 'Bearer ' + FuncionesServices.getAccessToken(),
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY,
        transactionId: Funciones.generarCorrelativo(),
        correlationId: Funciones.generarCorrelativo(),
        businessProcess: process.env.REACT_APP_BUSINESS_PROCESS,
        applicationName: process.env.REACT_APP_NOMBRE_APLICACION,
        applicationUser: getScreenNameAuthenticated()
      },
      body: JSON.stringify({
        marcaLpdp: solicitud.marcaLpdp,
        solicitud: solicitud.solicitud
      })
    })

    if (response.ok) {
      if (response.headers.get('content-type') !== 'text/html') {
        const res = await response.json()
        if (res.Status === 'fail') {
          salidaJson.error = true
          salidaJson.mensajeError = res.Message
        } else {
          salidaJson.error = false
          salidaJson.res = res
        }
      } else {
        salidaJson.error = true
        salidaJson.mensajeError = obtenerMensajeErrorGeneral(null)
      }
    } else {
      salidaJson.error = true
      salidaJson.res = response
      salidaJson.mensajeError = obtenerMensajeErrorGeneral(salidaJson.res)
    }
  } catch (error) {
    console.error(error)
  }

  return salidaJson
}

export const getBeneficiarios = async (usuario, idSolicitudMultiple) => {
  let salidaJson = {
    error: false,
    mensajeError: null,
    res: {},
  }

  try {
    let atributos = [{ campo: 'idSolicitudMultiple', valor: idSolicitudMultiple }]

    const response = await fetch(Funciones.reemplazarUrlServicio(process.env.REACT_APP_WS_GET_BENEFICIARIOS, atributos), {
      method: 'get',
      headers: {
        Authorization: 'Bearer ' + FuncionesServices.getAccessToken(),
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY,
        transactionId: Funciones.generarCorrelativo(),
        correlationId: Funciones.generarCorrelativo(),
        businessProcess: process.env.REACT_APP_BUSINESS_PROCESS,
        applicationName: process.env.REACT_APP_NOMBRE_APLICACION,
        applicationUser: getScreenNameAuthenticated()
      },
    })

    if (response.ok) {
      if (response.headers.get('content-type') !== 'text/html') {
        const res = await response.json()
        if (res.Status === 'fail') {
          salidaJson.error = true
          salidaJson.mensajeError = res.Message
        } else if (res.statusCode === 500) {
          salidaJson.error = true
          salidaJson.res = response
          salidaJson.mensajeError = obtenerMensajeErrorGeneral(null)
        } else {
          salidaJson.error = false
          salidaJson.res = res.data
        }
      } else {
        salidaJson.error = true
        salidaJson.mensajeError = obtenerMensajeErrorGeneral(null)
      }
    } else {
      salidaJson.error = true
      salidaJson.res = response
      salidaJson.mensajeError = obtenerMensajeErrorGeneral(salidaJson.res)
    }
  } catch (error) {
    console.error(error)
  }

  return salidaJson
}

export const postBeneficiario = async (user, idSolicitud, beneficiario, usuario) => {
  let salidaJson = {
    error: false,
    mensajeError: null,
    res: {}
  }

  let objectToSend = {
    usuario: usuario,
    idSolicitud: idSolicitud,
    tipoBeneficiario: beneficiario.tipoBeneficiario,
    nombres: beneficiario.nombres,
    apellidoPaterno: beneficiario.apellidoPaterno,
    apellidoMaterno: beneficiario.apellidoMaterno,
    parentesco: beneficiario.parentesco,
    tipoDocumento:
      !beneficiario.tipoDocumento
        ?
        {
          "tipoDocumento": {
            "codigo": 0,
            "descripcion": ""
          }
        }
        :
        beneficiario.tipoDocumento
    ,
    numeroDocumento: !beneficiario.numeroDocumento ? "" : beneficiario.numeroDocumento,
    sexo: beneficiario.sexo,
    fechaNacimiento: beneficiario.fechaNacimiento,
    porcentajeBeneficio: beneficiario.porcentajeBeneficio,
    indicadorModificacionDatosPID: beneficiario.indicadorModificacionDatosPID
  }

  try {
    let atributos = [{ campo: 'idSolicitud', valor: idSolicitud }]

    const response = await fetch(Funciones.reemplazarUrlServicio(process.env.REACT_APP_WS_POST_BENEFICIARIOS, atributos), {
      method: 'post',
      headers: {
        Authorization: 'Bearer ' + FuncionesServices.getAccessToken(),
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY,
        transactionId: Funciones.generarCorrelativo(),
        correlationId: Funciones.generarCorrelativo(),
        businessProcess: process.env.REACT_APP_BUSINESS_PROCESS,
        applicationName: process.env.REACT_APP_NOMBRE_APLICACION,
        applicationUser: getScreenNameAuthenticated()
      },
      body: JSON.stringify(objectToSend),
    })

    if (response.ok) {
      if (response.headers.get('content-type') !== 'text/html') {
        const res = await response.json()
        if (res.Status === 'error') {
          salidaJson.error = true
          salidaJson.mensajeError = res.Message
        } else {
          salidaJson.error = false
          salidaJson.res = res
        }
      } else {
        salidaJson.error = true
        salidaJson.mensajeError = obtenerMensajeErrorGeneral(null)
      }
    } else {
      salidaJson.error = true
      salidaJson.res = response
      salidaJson.mensajeError = obtenerMensajeErrorGeneral(salidaJson.res)
    }
  } catch (error) {
    console.error(error)
  }
  return salidaJson
}

export const putBeneficiario = async (user, idSolicitud, beneficiario, usuario) => {
  let salidaJson = {
    error: false,
    mensajeError: null,
    res: {}
  }

  try {
    let atributos = [
      { campo: 'idSolicitud', valor: idSolicitud },
      { campo: 'idBeneficiario', valor: beneficiario.idBeneficiario }
    ]

    const response = await fetch(Funciones.reemplazarUrlServicio(process.env.REACT_APP_WS_PUT_BENEFICIARIOS, atributos), {
      method: 'put',
      headers: {
        Authorization: 'Bearer ' + FuncionesServices.getAccessToken(),
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY,
        transactionId: Funciones.generarCorrelativo(),
        correlationId: Funciones.generarCorrelativo(),
        businessProcess: process.env.REACT_APP_BUSINESS_PROCESS,
        applicationName: process.env.REACT_APP_NOMBRE_APLICACION,
        applicationUser: getScreenNameAuthenticated()
      },
      body: JSON.stringify({
        usuario: usuario,
        idBeneficiario: beneficiario.idBeneficiario,
        idSolicitud: idSolicitud,
        tipoBeneficiario: beneficiario.tipoBeneficiario,
        nombres: beneficiario.nombres,
        apellidoPaterno: beneficiario.apellidoPaterno,
        apellidoMaterno: beneficiario.apellidoMaterno,
        parentesco: beneficiario.parentesco,
        tipoDocumento: beneficiario.tipoDocumento,
        numeroDocumento: beneficiario.numeroDocumento,
        sexo: beneficiario.sexo,
        fechaNacimiento: beneficiario.fechaNacimiento,
        porcentajeBeneficio: beneficiario.porcentajeBeneficio,
        tutor: beneficiario.tutor,
        indicadorModificacionDatosPID: beneficiario.indicadorModificacionDatosPID
      })
    })

    if (response.ok) {
      if (response.headers.get('content-type') !== 'text/html') {
        const res = await response.json()
        if (res.Status === 'error') {
          salidaJson.error = true
          salidaJson.mensajeError = res.Message
        } else {
          salidaJson.error = false
          salidaJson.res = res
        }
      } else {
        salidaJson.error = true
        salidaJson.mensajeError = obtenerMensajeErrorGeneral(null)
      }
    } else {
      salidaJson.error = true
      salidaJson.res = response
      salidaJson.mensajeError = obtenerMensajeErrorGeneral(salidaJson.res)
    }
  } catch (error) {
    console.error(error)
  }
  return salidaJson
}

export const deleteBeneficiarios = async (usuario, idSolicitud, idBeneficiario, flag) => {
  let salidaJson = {
    error: false,
    mensajeError: null,
    res: {},
  }

  try {
    let atributos = [
      { campo: 'idSolicitud', valor: idSolicitud },
      { campo: 'idBeneficiario', valor: idBeneficiario },
    ]
    let parametros = [
      { campo: 'eliminarTutor', valor: flag },
    ]
    const response = await fetch(agregarParametros(Funciones.reemplazarUrlServicio(process.env.REACT_APP_WS_DELETE_BENEFICIARIOS, atributos), parametros), {
      method: 'delete',
      headers: {
        Authorization: 'Bearer ' + FuncionesServices.getAccessToken(),
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY,
        transactionId: Funciones.generarCorrelativo(),
        correlationId: Funciones.generarCorrelativo(),
        businessProcess: process.env.REACT_APP_BUSINESS_PROCESS,
        applicationName: process.env.REACT_APP_NOMBRE_APLICACION,
        applicationUser: getScreenNameAuthenticated()
      },
    })

    if (response.ok) {
      if (response.headers.get('content-type') !== 'text/html') {
        const res = await response.json()
        if (res.Status === 'error') {
          salidaJson.error = true
          salidaJson.mensajeError = res.Message
        } else {
          salidaJson.error = false
          salidaJson.res = res
        }
      } else {
        salidaJson.error = true
        salidaJson.mensajeError = obtenerMensajeErrorGeneral(null)
      }
    } else {
      salidaJson.error = true
      salidaJson.res = response
      salidaJson.mensajeError = obtenerMensajeErrorGeneral(salidaJson.res)
    }
  } catch (error) {
    console.error(error)
  }

  return salidaJson
}

export const getRequisitos = async (usuario, idSolicitudMultiple) => {
  let salidaJson = {
    error: false,
    mensajeError: null,
    res: {}
  }

  try {
    //Mapeo Campos
    let atributos = [
      { campo: 'idSolicitudMultiple', valor: idSolicitudMultiple }
    ]

    const response = await fetch(Funciones.reemplazarUrlServicio(process.env.REACT_APP_WS_GET_REQUISITOS, atributos), {
      method: 'get',
      headers: {
        Authorization: 'Bearer ' + FuncionesServices.getAccessToken(),
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY,
        transactionId: Funciones.generarCorrelativo(),
        correlationId: Funciones.generarCorrelativo(),
        businessProcess: process.env.REACT_APP_BUSINESS_PROCESS,
        applicationName: process.env.REACT_APP_NOMBRE_APLICACION,
        applicationUser: getScreenNameAuthenticated()
      }
    })

    if (response.ok) {
      if (response.headers.get('content-type') !== 'text/html') {
        const res = await response.json()
        if (res.Status === 'fail') {
          salidaJson.error = true
          salidaJson.mensajeError = res.Message
        } else {
          salidaJson.error = false
          salidaJson.res = res.data
        }
      } else {
        salidaJson.error = true
        salidaJson.mensajeError = obtenerMensajeErrorGeneral(null)
      }
    } else {
      salidaJson.error = true
      salidaJson.res = response
      salidaJson.mensajeError = obtenerMensajeErrorGeneral(salidaJson.res)
    }
  } catch (error) {
    console.error(error)
  }

  return salidaJson
}

export const postRequisito = async (usuario, idSolicitudMultiple, requisito) => {
  let salidaJson = {
    error: false,
    mensajeError: null,
    res: {}
  }

  try {
    let atributos = [{ campo: 'idSolicitudMultiple', valor: idSolicitudMultiple }]

    const response = await fetch(Funciones.reemplazarUrlServicio(process.env.REACT_APP_WS_POST_REQUISITO, atributos), {
      method: 'post',
      headers: {
        Authorization: 'Bearer ' + FuncionesServices.getAccessToken(),
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY,
        transactionId: Funciones.generarCorrelativo(),
        correlationId: Funciones.generarCorrelativo(),
        businessProcess: process.env.REACT_APP_BUSINESS_PROCESS,
        applicationName: process.env.REACT_APP_NOMBRE_APLICACION,
        applicationUser: getScreenNameAuthenticated()
      },
      body: JSON.stringify(requisito),
    })

    if (response.ok) {
      if (response.headers.get('content-type') !== 'text/html') {
        const res = await response.json()
        if (res.status === 'error') {
          salidaJson.error = true
          salidaJson.mensajeError = res.message
        } else if (res.Status === 'fail' || res.Status === 'error') {
          salidaJson.error = true
          salidaJson.mensajeError = res.Message
        } else {
          salidaJson.error = false
          salidaJson.res = res
        }
      } else {
        salidaJson.error = true
        salidaJson.mensajeError = obtenerMensajeErrorGeneral(null)
      }
    } else {
      salidaJson.error = true
      salidaJson.res = response
      salidaJson.mensajeError = obtenerMensajeErrorGeneral(salidaJson.res)
    }
  } catch (error) {
    console.error(error)
  }

  return salidaJson
}

export const finalizarSolicitud = async (idSolicitudMultiple,
  codigoIntermediario, idProspecto, codigoCotizacion, usuario) => {
  let salidaJson = {
    error: false,
    mensajeError: null,
    res: {}
  }

  try {
    let atributos = [{ campo: 'idSolicitudMultiple', valor: idSolicitudMultiple }]

    const response = await fetch(Funciones.reemplazarUrlServicio(process.env.REACT_APP_WS_FINALIZAR_SOLICITUD, atributos), {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY
      },
      body: JSON.stringify({
        codigoIntermediario,
        idProspecto,
        codigoCotizacion,
        usuario
      }),
    })

    if (response.ok) {
      if (response.headers.get('content-type') !== 'text/html') {
        const res = await response.json()
        if (res.Status === 'fail') {
          salidaJson.error = true
          salidaJson.mensajeError = res.Message
        } else {
          salidaJson.error = false
          salidaJson.res = res.data
        }
      } else {
        salidaJson.error = true
        salidaJson.mensajeError = obtenerMensajeErrorGeneral(null)
      }
    } else {
      salidaJson.error = true
      salidaJson.res = response
      salidaJson.mensajeError = obtenerMensajeErrorGeneral(salidaJson.res)
    }
  } catch (error) {
    console.error(error)
  }

  return salidaJson
}

const getListaUbicacion = async (usuario, parametros) => {
  let salidaJson = {
    error: false,
    mensajeError: null,
    res: {}
  }

  try {
    //Mapeo Campos
    const response = await fetch(agregarParametros(process.env.REACT_APP_WS_GET_UBICACION, parametros), {
      method: 'get',
      headers: {
        Authorization: 'Bearer ' + FuncionesServices.getAccessToken(),
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY,
        transactionId: Funciones.generarCorrelativo(),
        correlationId: Funciones.generarCorrelativo(),
        businessProcess: process.env.REACT_APP_BUSINESS_PROCESS,
        applicationName: process.env.REACT_APP_NOMBRE_APLICACION,
        applicationUser: getScreenNameAuthenticated()
      }
    })

    if (response.ok) {
      if (response.headers.get('content-type') !== 'text/html') {
        const res = await response.json()
        if (res.Status === 'fail') {
          salidaJson.error = true
          salidaJson.mensajeError = res.Message
        } else {
          salidaJson.error = false
          salidaJson.res = res.data
        }
      } else {
        salidaJson.error = true
        salidaJson.mensajeError = obtenerMensajeErrorGeneral(null)
      }
    } else {
      salidaJson.error = true
      salidaJson.res = response
      salidaJson.mensajeError = obtenerMensajeErrorGeneral(salidaJson.res)
    }
  } catch (error) {
    console.error(error)
  }

  return salidaJson
}

export const getDepartamentos = async (usuario) => {
  let parametros = [
    { campo: 'departamento', valor: 0 }
  ]
  return await getListaUbicacion(usuario, parametros)
}

export const getProvincias = async (usuario, codDepartamento) => {
  let parametros = [
    { campo: 'departamento', valor: codDepartamento },
    { campo: 'provincia', valor: 0 }
  ]
  return await getListaUbicacion(usuario, parametros)
}

export const getDistritos = async (usuario, codDepartamento, codProvincia) => {
  let parametros = [
    { campo: 'departamento', valor: codDepartamento },
    { campo: 'provincia', valor: codProvincia },
    { campo: 'distrito', valor: 0 }
  ]
  return await getListaUbicacion(usuario, parametros)
}

export const getCentrosMedicos = async (usuario, codDepartamento, codProvincia) => {
  let salidaJson = {
    error: false,
    mensajeError: null,
    res: {}
  }

  try {
    //Mapeo Campos
    let parametros = [
      { campo: 'departamento', valor: codDepartamento },
      { campo: 'provincia', valor: codProvincia }
    ]

    const response = await fetch(agregarParametros(process.env.REACT_APP_WS_GET_CENTROS_MEDICOS, parametros), {
      method: 'get',
      headers: {
        Authorization: 'Bearer ' + FuncionesServices.getAccessToken(),
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY,
        transactionId: Funciones.generarCorrelativo(),
        correlationId: Funciones.generarCorrelativo(),
        businessProcess: process.env.REACT_APP_BUSINESS_PROCESS,
        applicationName: process.env.REACT_APP_NOMBRE_APLICACION,
        applicationUser: getScreenNameAuthenticated()
      }
    })

    if (response.ok) {
      if (response.headers.get('content-type') !== 'text/html') {
        const res = await response.json()
        if (res.Status === 'fail') {
          salidaJson.error = true
          salidaJson.mensajeError = res.Message
        } else {
          salidaJson.error = false
          salidaJson.res = res.data
        }
      } else {
        salidaJson.error = true
        salidaJson.mensajeError = obtenerMensajeErrorGeneral(null)
      }
    } else {
      salidaJson.error = true
      salidaJson.res = response
      salidaJson.mensajeError = obtenerMensajeErrorGeneral(salidaJson.res)
    }
  } catch (error) {
    console.error(error)
  }

  return salidaJson
}

export const getOperadores = async (usuario, idMedioPago) => {
  let salidaJson = {
    error: false,
    mensajeError: null,
    res: {},
  }

  try {
    let parametros = [
      { campo: 'tipoCobranza', valor: idMedioPago },
    ]

    const response = await fetch(agregarParametros(process.env.REACT_APP_WS_GET_OPERADORES, parametros), {
      method: 'get',
      headers: {
        Authorization: 'Bearer ' + FuncionesServices.getAccessToken(),
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY,
        transactionId: Funciones.generarCorrelativo(),
        correlationId: Funciones.generarCorrelativo(),
        businessProcess: process.env.REACT_APP_BUSINESS_PROCESS,
        applicationName: process.env.REACT_APP_NOMBRE_APLICACION,
        applicationUser: getScreenNameAuthenticated()
      },
    })

    if (response.ok) {
      if (response.headers.get('content-type') !== 'text/html') {
        const res = await response.json()
        if (res.Status === 'error') {
          salidaJson.error = true
          salidaJson.mensajeError = res.Message
        } else {
          salidaJson.error = false
          salidaJson.res = res.data
        }
      } else {
        salidaJson.error = true
        salidaJson.mensajeError = obtenerMensajeErrorGeneral(null)
      }
    } else {
      salidaJson.error = true
      salidaJson.res = response
      salidaJson.mensajeError = obtenerMensajeErrorGeneral(salidaJson.res)
    }
  } catch (error) {
    console.error(error)
  }

  return salidaJson
}

export const getPagoRecurrente = async (usuario, idSolicitudMultiple) => {
  let salidaJson = {
    error: false,
    mensajeError: null,
    res: {}
  }

  try {
    //Mapeo Campos
    let atributos = [
      { campo: 'idSolicitudMultiple', valor: idSolicitudMultiple }
    ]

    const response = await fetch(Funciones.reemplazarUrlServicio(process.env.REACT_APP_WS_GET_PAGO_RECURRENTE, atributos), {
      method: 'get',
      headers: {
        Authorization: 'Bearer ' + FuncionesServices.getAccessToken(),
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY,
        transactionId: Funciones.generarCorrelativo(),
        correlationId: Funciones.generarCorrelativo(),
        businessProcess: process.env.REACT_APP_BUSINESS_PROCESS,
        applicationName: process.env.REACT_APP_NOMBRE_APLICACION,
        applicationUser: getScreenNameAuthenticated()
      }
    })

    if (response.ok) {
      if (response.headers.get('content-type') !== 'text/html') {
        const res = await response.json()
        if (res.Status === 'error') {
          salidaJson.error = true
          salidaJson.mensajeError = res.Message
        } else {
          salidaJson.error = false
          salidaJson.res = res.data
        }
      } else {
        salidaJson.error = true
        salidaJson.mensajeError = obtenerMensajeErrorGeneral(null)
      }
    } else {
      salidaJson.error = true
      salidaJson.res = response
      salidaJson.mensajeError = obtenerMensajeErrorGeneral(salidaJson.res)
    }
  } catch (error) {
    console.error(error)
  }

  return salidaJson
}

export const putPagoRecurrente = async (usuario, idSolicitudMultiple, recurrente, check) => {
  let salidaJson = {
    error: false,
    mensajeError: null,
    res: {}
  }

  try {
    //Mapeo Campos
    let atributos = [
      { campo: 'idSolicitudMultiple', valor: idSolicitudMultiple }
    ]

    let parametros = [
      { campo: 'usarMismoMedioPago', valor: check }
    ]

    const response = await fetch(agregarParametros(Funciones.reemplazarUrlServicio(process.env.REACT_APP_WS_PUT_PAGO_RECURRENTE, atributos), parametros), {
      method: 'put',
      headers: {
        Authorization: 'Bearer ' + FuncionesServices.getAccessToken(),
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY,
        transactionId: Funciones.generarCorrelativo(),
        correlationId: Funciones.generarCorrelativo(),
        businessProcess: process.env.REACT_APP_BUSINESS_PROCESS,
        applicationName: process.env.REACT_APP_NOMBRE_APLICACION,
        applicationUser: getScreenNameAuthenticated()
      },
      body: JSON.stringify(recurrente)
    })

    if (response.ok) {
      if (response.headers.get('content-type') !== 'text/html') {
        const res = await response.json()
        if (res.Status === 'error') {
          salidaJson.error = true
          salidaJson.mensajeError = res.Message
        } else {
          salidaJson.error = false
          salidaJson.res = res.data
        }
      } else {
        salidaJson.error = true
        salidaJson.mensajeError = obtenerMensajeErrorGeneral(null)
      }
    } else {
      salidaJson.error = true
      salidaJson.res = response
      salidaJson.mensajeError = obtenerMensajeErrorGeneral(salidaJson.res)
    }
  } catch (error) {
    console.error(error)
  }

  return salidaJson
}

export const postLogs = async (codigoIntermediario, tag, idProspecto, codigoCotizacion, numeroSolicitud, detalleError) => {
  let salidaJson = {
    error: false,
    mensajeError: null,
    res: {}
  }

  try {
    const response = await fetch(process.env.REACT_APP_WS_POST_LOG, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY
      },
      body: JSON.stringify({
        codigoIntermediario,
        tag,
        idProspecto,
        codigoCotizacion,
        numeroSolicitud,
        detalleError
      })
    })

    if (response.ok) {
      if (response.headers.get('content-type') !== 'text/html') {
        const res = await response.json()
        if (res.Status === 'error') {
          salidaJson.error = true
          salidaJson.mensajeError = res.Message
        } else {
          salidaJson.error = false
          salidaJson.res = res.data
        }
      } else {
        salidaJson.error = true
        salidaJson.mensajeError = obtenerMensajeErrorGeneral(null)
      }
    } else {
      salidaJson.error = true
      salidaJson.res = response
      salidaJson.mensajeError = obtenerMensajeErrorGeneral(salidaJson.res)
    }
  } catch (error) {
    console.error(error)
  }

  return salidaJson
}

export const getListPagos = async (usuario, idSolicitudMultiple) => {
  let salidaJson = {
    error: false,
    mensajeError: null,
    res: {}
  }

  try {
    let atributos = [{ campo: 'idSolicitudMultiple', valor: idSolicitudMultiple }]

    const response = await fetch(Funciones.reemplazarUrlServicio(process.env.REACT_APP_WS_GET_PAYMENTS, atributos), {
      method: 'get',
      headers: {
        Authorization: 'Bearer ' + FuncionesServices.getAccessToken(),
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY,
        transactionId: Funciones.generarCorrelativo(),
        correlationId: Funciones.generarCorrelativo(),
        businessProcess: process.env.REACT_APP_BUSINESS_PROCESS,
        applicationName: process.env.REACT_APP_NOMBRE_APLICACION,
        applicationUser: getScreenNameAuthenticated()
      }
    })

    if (response.ok) {
      if (response.headers.get('content-type') !== 'text/html') {
        const res = await response.json()
        if (res.Status === 'error') {
          salidaJson.error = true
          salidaJson.mensajeError = res.Message
        } else {
          salidaJson.error = false
          salidaJson.res = res.data
        }
      } else {
        salidaJson.error = true
        salidaJson.mensajeError = obtenerMensajeErrorGeneral(null)
      }
    } else {
      salidaJson.error = true
      salidaJson.res = response
      salidaJson.mensajeError = obtenerMensajeErrorGeneral(salidaJson.res)
    }
  } catch (error) {
    console.error(error)
  }
  return salidaJson
}

export const getPagosSolicitud = async (usuario, idSolicitudMultiple) => {
  let salidaJson = {
    error: false,
    mensajeError: null,
    res: {}
  }

  try {
    let atributos = [{ campo: 'idSolicitudMultiple', valor: idSolicitudMultiple }]

    const response = await fetch(Funciones.reemplazarUrlServicio(process.env.REACT_APP_WS_GET_PAYMENTS_SOLICITUD, atributos), {
      method: 'get',
      headers: {
        Authorization: 'Bearer ' + FuncionesServices.getAccessToken(),
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY,
        transactionId: Funciones.generarCorrelativo(),
        correlationId: Funciones.generarCorrelativo(),
        businessProcess: process.env.REACT_APP_BUSINESS_PROCESS,
        applicationName: process.env.REACT_APP_NOMBRE_APLICACION,
        applicationUser: getScreenNameAuthenticated()
      }
    })

    if (response.ok) {
      if (response.headers.get('content-type') !== 'text/html') {
        const res = await response.json()
        if (res.Status === 'error') {
          salidaJson.error = true
          salidaJson.mensajeError = res.Message
        } else {
          salidaJson.error = false
          salidaJson.res = res.data
        }
      } else {
        salidaJson.error = true
        salidaJson.mensajeError = obtenerMensajeErrorGeneral(null)
      }
    } else {
      salidaJson.error = true
      salidaJson.res = response
      salidaJson.mensajeError = obtenerMensajeErrorGeneral(salidaJson.res)
    }
  } catch (error) {
    console.error(error)
  }
  return salidaJson
}

export const postSafetyPay = async (usuario, obj) => {
  let salidaJson = {
    error: false,
    mensajeError: null,
    res: {}
  }

  try {

    const response = await fetch(process.env.REACT_APP_WS_POST_SAFETYPAY, {
      method: 'post',
      headers: {
        Authorization: 'Bearer ' + FuncionesServices.getAccessToken(),
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY,
        transactionId: Funciones.generarCorrelativo(),
        correlationId: Funciones.generarCorrelativo(),
        businessProcess: process.env.REACT_APP_BUSINESS_PROCESS,
        applicationName: process.env.REACT_APP_NOMBRE_APLICACION,
        applicationUser: getScreenNameAuthenticated()
      },
      body: JSON.stringify(obj)
    })

    if (response.ok) {
      if (response.headers.get('content-type') !== 'text/html') {
        const res = await response.json()
        if (res.Status === 'fail') {
          salidaJson.error = true
          salidaJson.mensajeError = res.Message
        } else {
          salidaJson.error = false
          salidaJson.res = res.data
        }
      } else {
        salidaJson.error = true
        salidaJson.mensajeError = obtenerMensajeErrorGeneral(null)
      }
    } else {
      salidaJson.error = true
      salidaJson.res = response
      salidaJson.mensajeError = obtenerMensajeErrorGeneral(salidaJson.res)
    }
  } catch (error) {
    console.error(error)
  }

  return salidaJson
}

export const putPayment = async (usuario, obj, idSolicitudMultiple) => {
  let salidaJson = {
    error: false,
    mensajeError: null,
    res: {}
  }

  try {
    let atributos = [{ campo: 'idSolicitudMultiple', valor: idSolicitudMultiple }]

    const response = await fetch(Funciones.reemplazarUrlServicio(process.env.REACT_APP_WS_PUT_PAYMENT, atributos), {
      method: 'put',
      headers: {
        Authorization: 'Bearer ' + FuncionesServices.getAccessToken(),
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY,
        transactionId: Funciones.generarCorrelativo(),
        correlationId: Funciones.generarCorrelativo(),
        businessProcess: process.env.REACT_APP_BUSINESS_PROCESS,
        applicationName: process.env.REACT_APP_NOMBRE_APLICACION,
        applicationUser: getScreenNameAuthenticated()
      },
      body: JSON.stringify(obj)
    })

    if (response.ok) {
      if (response.headers.get('content-type') !== 'text/html') {
        const res = await response.json()
        if (res.status === 'fail' || res.status === 'error') {
          salidaJson.error = true
          salidaJson.mensajeError = res.message
        } else if (res.Status === 'fail' || res.Status === 'error') {
          salidaJson.error = true
          salidaJson.mensajeError = res.Message
        } else {
          salidaJson.error = false
          salidaJson.res = res.data
        }
      } else {
        salidaJson.error = true
        salidaJson.mensajeError = obtenerMensajeErrorGeneral(null)
      }
    } else {
      salidaJson.error = true
      salidaJson.res = response
      salidaJson.mensajeError = obtenerMensajeErrorGeneral(salidaJson.res)
    }
  } catch (error) {
    console.error(error)
  }
  return salidaJson
}

export const getEstadoFirma = async (idSolicitudMultiple) => {
  let salidaJson = {
    error: false,
    mensajeError: null,
    res: {}
  }

  try {
    //Mapeo Campos
    let atributos = [
      { campo: 'idSolicitudMultiple', valor: idSolicitudMultiple }
    ]

    const response = await fetch(Funciones.reemplazarUrlServicio(process.env.REACT_APP_WS_GET_ESTADO_FIRMA, atributos), {
      method: 'get',
      headers: {
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY
      }
    })

    if (response.ok) {
      if (response.headers.get('content-type') !== 'text/html') {
        const res = await response.json()
        if (res.status === 'error') {
          salidaJson.error = true
          salidaJson.mensajeError = res.message
        } else if (res.Status === 'fail') {
          salidaJson.error = true
          salidaJson.mensajeError = res.Message
        } else {
          salidaJson.error = false
          salidaJson.res = res.data
        }
      } else {
        salidaJson.error = true
        salidaJson.mensajeError = obtenerMensajeErrorGeneral(null)
      }
    } else {
      salidaJson.error = true
      salidaJson.res = response
      salidaJson.mensajeError = obtenerMensajeErrorGeneral(salidaJson.res)
    }
  } catch (error) {
    console.error(error)
  }

  return salidaJson
}

export const postActivarContingencia = async (idSolicitudMultiple) => {
  let salidaJson = {
    error: false,
    mensajeError: null,
    res: {}
  }

  try {
    //Mapeo Campos
    let atributos = [
      { campo: 'idSolicitudMultiple', valor: idSolicitudMultiple }
    ]

    const response = await fetch(Funciones.reemplazarUrlServicio(process.env.REACT_APP_WS_POST_ACTIVAR_CONTINGENCIA, atributos), {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY
      }
    })

    if (response.ok) {
      if (response.headers.get('content-type') !== 'text/html') {
        const res = await response.json()
        if (res.status === 'error') {
          salidaJson.error = true
          salidaJson.mensajeError = res.message
        } else if (res.Status === 'fail') {
          salidaJson.error = true
          salidaJson.mensajeError = res.Message
        } else {
          salidaJson.error = false
          salidaJson.res = res
        }
      } else {
        salidaJson.error = true
        salidaJson.mensajeError = obtenerMensajeErrorGeneral(null)
      }
    } else {
      salidaJson.error = true
      salidaJson.res = response
      salidaJson.mensajeError = obtenerMensajeErrorGeneral(salidaJson.res)
    }
  } catch (error) {
    console.error(error)
  }

  return salidaJson
}

export const getSessionTokenNiubuz = async (usuario, monto, codMoneda, email) => {
  let salidaJson = {
    error: false,
    mensajeError: null,
    res: {}
  }

  try {

    let request = {
      monto: monto,
      codigoMoneda: codMoneda,
      email: email
    }

    const response = await fetch(process.env.REACT_APP_WS_GET_SESSION_TOKEN_NIUBIZ, {
      method: 'post',
      headers: {
        Authorization: 'Bearer ' + FuncionesServices.getAccessToken(),
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY,
        transactionId: Funciones.generarCorrelativo(),
        correlationId: Funciones.generarCorrelativo(),
        businessProcess: process.env.REACT_APP_BUSINESS_PROCESS,
        applicationName: process.env.REACT_APP_NOMBRE_APLICACION,
        applicationUser: getScreenNameAuthenticated()
      },
      body: JSON.stringify(request),
    })

    if (response.ok) {
      if (response.headers.get('content-type') !== 'text/html') {
        const res = await response.json()
        if (res.status === 'error') {
          salidaJson.error = true
          salidaJson.mensajeError = res.message
        } else if (res.Status === 'fail' || res.Status === 'error') {
          salidaJson.error = true
          salidaJson.mensajeError = res.Message
        } else {
          salidaJson.error = false
          salidaJson.res = res.data
        }
      } else {
        salidaJson.error = true
        salidaJson.mensajeError = obtenerMensajeErrorGeneral(null)
      }
    } else {
      salidaJson.error = true
      salidaJson.res = response
      salidaJson.mensajeError = obtenerMensajeErrorGeneral(salidaJson.res)
    }
  } catch (error) {
    console.error(error)
  }

  return salidaJson
}

export const getAutorizacionNuibiz = async (usuario, request) => {
  let salidaJson = {
    error: false,
    mensajeError: null,
    res: {}
  }

  try {

    const response = await fetch(process.env.REACT_APP_WS_GET_AUTORIZACION_NIUBIZ, {
      method: 'post',
      headers: {
        Authorization: 'Bearer ' + FuncionesServices.getAccessToken(),
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY,
        transactionId: Funciones.generarCorrelativo(),
        correlationId: Funciones.generarCorrelativo(),
        businessProcess: process.env.REACT_APP_BUSINESS_PROCESS,
        applicationName: process.env.REACT_APP_NOMBRE_APLICACION,
        applicationUser: getScreenNameAuthenticated()
      },
      body: JSON.stringify(request),
    })

    if (response.ok) {
      if (response.headers.get('content-type') !== 'text/html') {
        const res = await response.json()
        if (res.status === 'fail' || res.status === 'error') {
          salidaJson.error = true
          salidaJson.mensajeError = res.message
        } else if (res.Status === 'fail' || res.Status === 'error') {
          salidaJson.error = true
          salidaJson.mensajeError = res.Message
        } else {
          salidaJson.error = false
          salidaJson.res = res.data
        }
      } else {
        salidaJson.error = true
        salidaJson.mensajeError = obtenerMensajeErrorGeneral(null)
      }
    } else {
      salidaJson.error = true
      salidaJson.res = response
      salidaJson.mensajeError = obtenerMensajeErrorGeneral(salidaJson.res)
    }
  } catch (error) {
    console.error(error)
  }

  return salidaJson
}

export const getEstados = async (usuario, idSolicitudMultiple) => {
  let salidaJson = {
    error: false,
    mensajeError: null,
    res: {}
  }

  try {
    //Mapeo Campos
    let atributos = [
      { campo: 'idSolicitudMultiple', valor: idSolicitudMultiple }
    ]

    const response = await fetch(Funciones.reemplazarUrlServicio(process.env.REACT_APP_WS_GET_SOLICITUDES_ESTADOS, atributos), {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + FuncionesServices.getAccessToken(),
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY,
        transactionId: Funciones.generarCorrelativo(),
        correlationId: Funciones.generarCorrelativo(),
        businessProcess: process.env.REACT_APP_BUSINESS_PROCESS,
        applicationName: process.env.REACT_APP_NOMBRE_APLICACION,
        applicationUser: getScreenNameAuthenticated()
      }
    })

    if (response.ok) {
      if (response.headers.get('content-type') !== 'text/html') {
        const res = await response.json()
        if (res.status === 'error') {
          salidaJson.error = true
          salidaJson.mensajeError = res.message
        } else if (res.Status === 'fail') {
          salidaJson.error = true
          salidaJson.mensajeError = res.Message
        } else {
          salidaJson.error = false
          salidaJson.res = res
        }
      } else {
        salidaJson.error = true
        salidaJson.mensajeError = obtenerMensajeErrorGeneral(null)
      }
    } else {
      salidaJson.error = true
      salidaJson.res = response
      salidaJson.mensajeError = obtenerMensajeErrorGeneral(salidaJson.res)
    }
  } catch (error) {
    console.error(error)
  }

  return salidaJson
}

export const postPagoLink = async (usuario, request) => {
  let salidaJson = {
    error: false,
    mensajeError: null,
    res: {}
  }

  try {

    const response = await fetch(process.env.REACT_APP_WS_POST_PAGO_LINK, {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + FuncionesServices.getAccessToken(),
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY,
        transactionId: Funciones.generarCorrelativo(),
        correlationId: Funciones.generarCorrelativo(),
        businessProcess: process.env.REACT_APP_BUSINESS_PROCESS,
        applicationName: process.env.REACT_APP_NOMBRE_APLICACION,
        applicationUser: getScreenNameAuthenticated()
      },
      body: JSON.stringify(request)
    })

    if (response.status === 200) {
      const res = await response.json()
      salidaJson.error = false
      salidaJson.res = res
    } else if (response.status === 422) {
      const res = await response.json()
      salidaJson.error = true
      salidaJson.showPopupError = true
      salidaJson.mensajeError = res.message
    } else {
      salidaJson.error = true
      salidaJson.mensajeError = obtenerMensajeErrorGeneral(null)
    }
  } catch (error) {
    console.error(error)
  }

  return salidaJson
}

export const getEstadoPagoLink = async (usuario, idSolicitudMultiple) => {
  let salidaJson = {
    error: false,
    mensajeError: null,
    res: {}
  }

  try {
    //Mapeo Campos
    let atributos = [
      { campo: 'idSolicitudMultiple', valor: idSolicitudMultiple }
    ]

    const response = await fetch(Funciones.reemplazarUrlServicio(process.env.REACT_APP_WS_GET_ESTADO_PAGO_LINK, atributos), {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + FuncionesServices.getAccessToken(),
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY,
        transactionId: Funciones.generarCorrelativo(),
        correlationId: Funciones.generarCorrelativo(),
        businessProcess: process.env.REACT_APP_BUSINESS_PROCESS,
        applicationName: process.env.REACT_APP_NOMBRE_APLICACION,
        applicationUser: getScreenNameAuthenticated()
      }
    })

    if (response.ok) {
      if (response.headers.get('content-type') !== 'text/html') {
        const res = await response.json()
        if (res.status === 'error') {
          salidaJson.error = true
          salidaJson.mensajeError = res.message
        } else if (res.Status === 'fail') {
          salidaJson.error = true
          salidaJson.mensajeError = res.Message
        } else {
          salidaJson.error = false
          salidaJson.res = res.data
        }
      } else {
        salidaJson.error = true
        salidaJson.mensajeError = obtenerMensajeErrorGeneral(null)
      }
    } else {
      salidaJson.error = true
      salidaJson.res = response
      salidaJson.mensajeError = obtenerMensajeErrorGeneral(salidaJson.res)
    }
  } catch (error) {
    console.error(error)
  }

  return salidaJson
}

export const getProductoConfiguraciones = async (usuario, codigoProducto, codigoSubProducto) => {

  let salidaJson = {
    error: false,
    mensajeError: null,
    res: {}
  }

  try {
    let atributos = [
      { campo: 'codigoProducto', valor: codigoProducto },
      { campo: 'codigoSubProducto', valor: codigoSubProducto }
    ]

    const response = await fetch(Funciones.reemplazarUrlServicio(process.env.REACT_APP_WS_GET_PRODUCTO_CONFIGURACION, atributos), {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + FuncionesServices.getAccessToken(),
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY,
        transactionId: Funciones.generarCorrelativo(),
        correlationId: Funciones.generarCorrelativo(),
        businessProcess: process.env.REACT_APP_BUSINESS_PROCESS,
        applicationName: process.env.REACT_APP_NOMBRE_APLICACION,
        applicationUser: getScreenNameAuthenticated()
      }
    })

    if (response.ok) {
      if (response.headers.get('content-type') !== 'text/html') {
        const res = await response.json()
        if (res.status === 'error') {
          salidaJson.error = true
          salidaJson.mensajeError = res.message
        } else if (res.Status === 'fail') {
          salidaJson.error = true
          salidaJson.mensajeError = res.Message
        } else {
          salidaJson.error = false
          salidaJson.res = res
        }
      } else {
        salidaJson.error = true
        salidaJson.mensajeError = obtenerMensajeErrorGeneral(null)
      }
    } else {
      salidaJson.error = true
      salidaJson.res = response
      salidaJson.mensajeError = obtenerMensajeErrorGeneral(salidaJson.res)
    }
  } catch (error) {
    console.error(error)
  }

  return salidaJson
}

export const getIntermediario = async (usuario, idIntermediario) => {
  let salidaJson = {
    error: false,
    mensajeError: null,
    res: {}
  }

  try {
    //Mapeo Campos
    let atributos = [{ campo: 'idIntermediario', valor: idIntermediario }]

    const response = await fetch(Funciones.reemplazarUrlServicio(process.env.REACT_APP_WS_GET_INTERMEDIARIO, atributos), {
      method: 'get',
      headers: {
        Authorization: 'Bearer ' + FuncionesServices.getAccessToken(),
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY,
        transactionId: Funciones.generarCorrelativo(),
        correlationId: Funciones.generarCorrelativo(),
        businessProcess: process.env.REACT_APP_BUSINESS_PROCESS,
        applicationName: process.env.REACT_APP_NOMBRE_APLICACION,
        applicationUser: getScreenNameAuthenticated()
      }
    })

    if (response.ok) {
      if (response.headers.get('content-type') !== 'text/html') {
        const res = await response.json()
        if (res.Status === 'error') {
          salidaJson.error = true
          salidaJson.mensajeError = res.Message
        } else {
          salidaJson.error = false
          salidaJson.res = res.data
        }
      } else {
        salidaJson.error = true
        salidaJson.mensajeError = obtenerMensajeErrorGeneral(null)
      }
    } else {
      salidaJson.error = true
      salidaJson.res = response
      salidaJson.mensajeError = obtenerMensajeErrorGeneral(salidaJson.res)
    }
  } catch (error) {
    console.error(error)
  }

  return salidaJson
}